import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Invoice } from '../../invoice.model';
import { InvoicesDataProvider } from '../../../../../shared/services/invoice/invoices-data-service/invoices.data.service';
import { MessageService } from '../../../../../shared/services/helpers/message-service/message.service';
import { InvoiceServiceProvider } from '../../../../../shared/services/invoice/invoice-service/invoice.service';
import { Subject } from 'rxjs/Subject';
import { InvoicesOverviewRequest, InvoiceViewBlock } from '../invoice.model';

@Component({
	selector: 'invoices-view-block',
	template: require('./invoices-view-block.component.html'),
	styles: [require('./invoices-view-block.component.scss')]
})
export class InvoicesViewBlockComponent implements OnInit {
	_jobId: number;
	@Input('jobId')
	set jobId(value) {
		if (value) {
			this._jobId = value;
			this.getInvoicesOverview();
		}
	}

	get jobId() {
		return this._jobId;
	}

	@Input('leadId') leadId: number = null;
	@Output('sendInvoiceEvent')
	sendInvoiceEvent: EventEmitter<any> = new EventEmitter<any>();
	@Output('createNewInvoiceEvent')
	createNewInvoiceEvent: EventEmitter<any> = new EventEmitter<any>();
	shootProofInvoiceLayout;
	selectedInvoiceId: number;
	showLoadingBlock = true;
	invoicesSN: Array<InvoiceViewBlock> = [];

	private unsubscribe: Subject<void> = new Subject();

	constructor(
		private invoiceDataService: InvoicesDataProvider,
		private messageService: MessageService,
		private invoiceService: InvoiceServiceProvider
	) {}

	ngOnInit(): void {
		this.shouldUpdateInvoiceObservalble();
	}

	ngOnDestroy(): void {
		this.invoiceDataService.destroyInvoiceUpdatedObservable();
		this.unsubscribe.next();
	}

	getInvoicesOverview(): void {
		this.invoiceDataService
			.getInvoiceOverviewV1(this.jobId)
			.finally(() => (this.showLoadingBlock = false))
			.subscribe(
				(data: InvoicesOverviewRequest) => this.succesGetInvoicesOverview(data),
				error => this.messageService.showDefaultErrorMessage(error)
			);
	}

	private shouldUpdateInvoiceObservalble(): void {
		this.invoiceDataService.shouldInvoiceBeUpdatedObservable
			.takeUntil(this.unsubscribe)
			.filter(value => !!value && value === 'UPDATE_SN_INVOICES')
			.subscribe(() => this.getInvoicesOverview());
	}

	private succesGetInvoicesOverview(data: InvoicesOverviewRequest): void {
		const {
			shootProofInvoiceLayout,
			snInvoiceLayout,
			fundyInvoiceLayout
		} = data.data;

		this.shootProofInvoiceLayout = shootProofInvoiceLayout;

		if (
			fundyInvoiceLayout !== null &&
			fundyInvoiceLayout.invoices.length !== 0
		) {
			const mergedInvoices = snInvoiceLayout.invoices.concat(
				fundyInvoiceLayout.invoices
			);
			snInvoiceLayout.invoices = mergedInvoices;
		}

		this.invoicesSN = this.invoiceService.setFormattedDaysToDue(
			JSON.parse(JSON.stringify(snInvoiceLayout.invoices))
		);
	}

	sendInvoice(invoiceId: number): void {
		this.sendInvoiceEvent.emit(invoiceId);
	}

	createNewInvoice(): void {
		this.leadId !== null
			? this.createNewInvoiceEvent.emit(this.leadId)
			: this.createNewInvoiceEvent.emit(this.jobId);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/invoices/invoices-view-block/invoices-view-block.component.ts